import { FC } from 'react'

import styles from './SsoButton.module.scss'
import { SsoButtonProps } from './SsoButton.types'

export const SsoButton: FC<SsoButtonProps> = ({ onClick, img, isLoading }) => {
  return (
    <button
      className={styles.button}
      onClick={onClick}
      disabled={isLoading}
      type='button'
      aria-busy={!!isLoading}
    >
      {img ? <img src={img.src} alt={img.alt} /> : 'SSO'}
    </button>
  )
}
